import React, { PropsWithChildren } from 'react';
import styles from './ExpandButton.module.scss';

export const ExpandButton = ({ onClick, children }: Props) => (
    <div className={styles.default} onClick={onClick}>
        {children}
    </div>
);

type Props = PropsWithChildren<{
    onClick: () => void;
}>;